import { getAuthAxiosBackend } from "../helpers/axios"
import axios from 'axios';


class FileServices{
    
    constructor(){
        this.axios = axios;
        this.cancelToken = axios.CancelToken.source();
    }

    download(uri, data = {}, onDownloadProgress){
        data.onDownloadProgress = onDownloadProgress;
        data.cancelToken = this.cancelToken.token;

        return getAuthAxiosBackend().get(uri, data);
    }

    responseBlob(response){
        return window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));        
    }
    
    responseBlobDownload(response, fileName = ''){
        fileName = fileName == '' ? new Date().getTime() : fileName;
        
        var fileURL = this.responseBlob(response);
        var fileLink = document.createElement('a');
            
        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
            
        fileLink.click();

        return Promise.resolve(true)
    }

    responseBlobOpen(response){
        var fileURL = this.responseBlob(response);
        window.open(fileURL, '_blank');

        return Promise.resolve(true)
    }

    cancelDownload(){
        this.cancelToken.cancel('Request canceled by the user');
        this.cancelToken = axios.CancelToken.source();
    }
}

export default new FileServices()